module.exports = __webpack_public_path__ + "static/Jus-38159c7f1064e3d54e2dc0243c94b6e3.svg";